import { Box, List, ListItem, ListItemText, Typography, TextField } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { getProductNames, getCustomerNames, getDSNames, getProductGroupNames,  getCustomerGroupNames} from "./scenarioApprovalUtils";
import CollapseSection from "../../../components/ui/CollapseSection";
import { useEffect, useState } from "react";

export default function ScenarioDetails() {
   const state = useSelector((store) => store.scenarioApproval);
   const { scenarioDetails, countries } = state;
   const {
      scenarioName,
      effectiveStartDate,
      effectiveEndDate,
      product,
      customers,
      scenarioDatasource,
      linearFCTimePeriod,
      runRateTimePeriod,
      financialFCTimePeriod,
      productGroup,
      customerGroups,
      countryID,
      customerBreakdownType,
      customerBreakdown,
      skuBreakdown
   } = scenarioDetails;
   const productNames = getProductNames(product);
   const customerNames = getCustomerNames(customers);
   const productGroupNames = getProductGroupNames(productGroup);
   const customerGroupNames = getCustomerGroupNames(customerGroups);
   const dsNames = getDSNames(scenarioDatasource);
   let country = countries.find(p => p.countryID == countryID);
   const selectedCountryName = country.countryName;
   const [CustomerList, setCustomerList] = useState(
      []
    );
   const [ProductList, setProductList] = useState([]);
   const [isAscByName, setAscByName] = useState(false);
   const [isAscByNumber, setAscByNumber] = useState(false);
   const [isAscByNameSKU, setAscByNameSKU] = useState(false);
   const [isAscByNumberSKU, setAscByNumberSKU] = useState(false);

   useEffect(()=>{
      let Fulllist = JSON.parse(JSON.stringify(product));
      let list = Fulllist.map((item) => item.product);
      setProductList(list);
   },[product]);

   useEffect(()=>{
      let Fulllist = JSON.parse(JSON.stringify(customers));
      let list = Fulllist.map((item) => item.customer);
      setCustomerList(list);
   },[customers]);

   if (scenarioDetails === null) {
      return null;
   }


   const period = `${new Date(effectiveStartDate).toLocaleDateString("en-UK",{
      year:'numeric',
      month:'2-digit',
      day:'2-digit'
   }).split("T")[0]} - ${
      new Date(effectiveEndDate).toLocaleDateString("en-UK",{
         year:'numeric',
         month:'2-digit',
         day:'2-digit'
      }).split("T")[0]
   }`;

   const handleClickSKU = (type) => {
      if (type === "name") {
        if (!isAscByNameSKU) {
          let list = JSON.parse(JSON.stringify(ProductList));
          //let list = Fulllist.map((item) => item.product);
          list = list.sort((a, b) =>
            getItemText(a).toLowerCase().trim() >
            getItemText(b).toLowerCase().trim()
              ? 1
              : -1
          );
          setProductList(list);
          setAscByNameSKU(true);
        } else {
          let list = JSON.parse(JSON.stringify(ProductList));
          list = list.sort((a, b) =>
            getItemText(a).toLowerCase().trim() <
            getItemText(b).toLowerCase().trim()
              ? 1
              : -1
          );
          setProductList(list);
          setAscByNameSKU(false);
        }
      } else {
        if (!isAscByNumberSKU) {
          let list = JSON.parse(JSON.stringify(ProductList));
          list = list.sort((a, b) =>
            getItemNumber(a) > getItemNumber(b) ? 1 : -1
          );
          setProductList(list);
          setAscByNumberSKU(true);
        } else {
          let list = JSON.parse(JSON.stringify(ProductList));
          list = list.sort((a, b) =>
            getItemNumber(a) < getItemNumber(b) ? 1 : -1
          );
          setProductList(list);
          setAscByNumberSKU(false);
        }
      }
    };

    const handleClick = (type) => {
      if (type === "name") {
        if (!isAscByName) {
          let list = JSON.parse(JSON.stringify(CustomerList));
          list = list.sort((a, b) =>
            getItemText(a).toLowerCase().trim() >
            getItemText(b).toLowerCase().trim()
              ? 1
              : -1
          );
          setCustomerList(list);
          setAscByName(true);
        } else {
          let list = JSON.parse(JSON.stringify(CustomerList));
          list = list.sort((a, b) =>
            getItemText(a).toLowerCase().trim() <
            getItemText(b).toLowerCase().trim()
              ? 1
              : -1
          );
          setCustomerList(list);
          setAscByName(false);
        }
      } else {
        if (!isAscByNumber) {
          let list = JSON.parse(JSON.stringify(CustomerList));
          list = list.sort((a, b) =>
            getItemNumber(a) > getItemNumber(b) ? 1 : -1
          );
          setCustomerList(list);
          setAscByNumber(true);
        } else {
          let list = JSON.parse(JSON.stringify(CustomerList));
          list = list.sort((a, b) =>
            getItemNumber(a) < getItemNumber(b) ? 1 : -1
          );
          setCustomerList(list);
          setAscByNumber(false);
        }
      }
    };
  

    
  const getItemText = (item) => {
   if (item.hasOwnProperty("name")) {
     return item.name;
   } else if (item.hasOwnProperty("productGroupName")) {
     return item.productGroupName;
   } else if (item.hasOwnProperty("productName")) {
     return item.productName;
   } else if (item.hasOwnProperty("customerGroupName")) {
     return item.customerGroupName;
   } else if (item.hasOwnProperty("customerName")) {
     return item.customerName;
   }
 };
 const getItemNumber = (item) => {
   if (item.hasOwnProperty("id")) {
     return item.sapCustomerNumber ? item.sapCustomerNumber : item.cip;
   } else if (item.hasOwnProperty("productGroupID")) {
     return 0;
   } else if (item.hasOwnProperty("productID")) {
     return item.clientProductCode;
   } else if (item.hasOwnProperty("customerGroupID")) {
     return 0;
   } else if (item.hasOwnProperty("customerID")) {
     return item.sapCustomerNumber;
   }
 };

   const listToNameStringSKUs = (list) => {
      let nameString = "";
      let listItems = JSON.parse(JSON.stringify(list));
      let filteredList = [];
      filteredList = listItems
        .map((item) => (item.name));
  
      nameString = filteredList.join("\n");
      return nameString;
    };

    const listToNameStringCustomers = (list) => {
      let nameString = "";
      let listItems = JSON.parse(JSON.stringify(list));
      let filteredList = [];
      filteredList = listItems
        .map((item) => (item.customerName));
  
      nameString = filteredList.join("\n");
      return nameString;
    };
///clientProductCode
   return (
      <Box  sx={{mt: 2,}}>
         {/* <Typography
            variant="subtitle1"
            gutterBottom
            sx={{ fontWeight: "bold", mt: 4, width:"100%" }}
            className="compHeading"
         >
            Scenario Details
         </Typography> */}
      <CollapseSection title="Scenario Details">
         <Box
            sx={{
               fontSize: "14px",
               ml : 2,
               mt: 2
            }}
         >
            <LabelValue label={"Scenario Of"} value={scenarioName} />
            <LabelValue label={"Scenario Name"} value={scenarioName} />
            <LabelValue label={"Country"} value={selectedCountryName} />
            <LabelValue label={"Validity Period"} value={period} />
            {/* <LabelValue label={"Linear FC Time Period"} value={linearFCTimePeriod} />
            <LabelValue label={"Run Rate Time Period"} value={runRateTimePeriod} />
            <LabelValue label={"Financial FC Time Period"} value={financialFCTimePeriod} /> */}
            {/* <Box> */}
					{/* <Typography sx={{ fontWeight: "600", fontSize: "14px", }} display="inline">
                  Product Group(s): {" "}
					</Typography> */}
					{/* <Typography display="inline" sx={{fontSize: "14px"}}>{productGroupNames.join(', ')}</Typography>
				</Box> */}
            <Box>
					<Typography sx={{ fontWeight: "600", fontSize: "14px" }}>
                  SKU(s): {" "}
					</Typography>
               <Typography
                sx={{ fontSize: "14px", mb: 2, cursor: "pointer" }}
                onClick={() => handleClickSKU("name")}
                display="inline"
              >
                Sort by Name |
              </Typography>{" "}
              <Typography
                sx={{ fontSize: "14px", mb: 2, cursor: "pointer" }}
                onClick={() => handleClickSKU("number")}
                display="inline"
              >
                Sort by Number
              </Typography>
               <TextField
                className={"fullHeight fullWidth"}
                overflow="scroll"
                multiline
                id="outlined-basic"
                label=""
                rows={6}
                variant="outlined"
                size="large"
                sx={{ "& .MuiMenuItem-root, .MuiInputBase-input":{
                  fontWeight: "400 !important"
                  } }}
                value={listToNameStringSKUs(ProductList)}
                style={{ overflowY: "auto" }}
                InputProps={{ autoComplete: "off" }}
              />
				</Box>
            <Box>
					<Typography sx={{ fontWeight: "600", fontSize: "14px" }} display="inline">
                  Customer Group(s): {" "}
					</Typography>
					<Typography display="inline" sx={{fontSize: "14px"}}>{customerGroupNames.join(', ')}</Typography>
				</Box>
            <Box>
					<Typography sx={{ fontWeight: "600", fontSize: "14px" }}>
                  Customer(s): {" "}
					</Typography>
               <Typography
                sx={{ fontSize: "14px", mb: 2,  cursor: "pointer" }}
                onClick={() => handleClick("name")}
                display="inline"
              >
                Sort by Name |
              </Typography>{" "}
              <Typography
                sx={{ fontSize: "14px", mb: 2, cursor: "pointer" }}
                onClick={() => handleClick("number")}
                display="inline"
              >
                Sort by Number
              </Typography>
					{/* <Typography display="inline" sx={{fontSize: "14px"}}>{customerNames.join(', ')}</Typography> */}
               <TextField
                className={"fullHeight fullWidth"}
                overflow="scroll"
                multiline
                id="outlined-basic"
                label=""
                rows={6}
                variant="outlined"
                size="large"
                sx={{ "& .MuiMenuItem-root, .MuiInputBase-input":{
                  fontWeight: "400 !important"
                  } }}
                value={listToNameStringCustomers(CustomerList)}
                style={{ overflowY: "auto" }}
                InputProps={{ autoComplete: "off" }}
              />
				</Box>
            <Box>
					<Typography sx={{ fontWeight: "600", fontSize: "14px" }} display="inline">
                  Data Source(s): {" "}
					</Typography>
					<Typography display="inline" sx={{fontSize: "14px"}}>{dsNames.join(', ')}</Typography>
				</Box>
            <Box>
					<Typography sx={{ fontWeight: "600", fontSize: "14px" }} display="inline">
                  Customer breakdown methodology (s): {" "}
					</Typography>
					<Typography display="inline" sx={{fontSize: "14px"}}>{customerBreakdownType} {" "} {customerBreakdown}</Typography>
				</Box>
            <Box mb={3}>
					<Typography sx={{ fontWeight: "600", fontSize: "14px" }} display="inline">
                  SKU breakdown methodology (s): {" "}
					</Typography>
					<Typography display="inline" sx={{fontSize: "14px"}}>{skuBreakdown}</Typography>
               {skuBreakdown !== undefined && skuBreakdown !== "" && skuBreakdown !=="External" && (<Typography display="inline">{" "}{customerBreakdown} </Typography>)}
				</Box>
         </Box>
      </CollapseSection>
      </Box>
   );
}

function LabelValue({ label, value }) {
   return (
      <div>
         <strong>{label}:</strong>&nbsp;{value}
      </div>
   );
}

function UnorderedList({ label, values }) {
   return (
      <>
         <Typography sx={{ mt:2, fontWeight: "bold" }}>{label}:</Typography>
         <Box
            sx={{ 
               width: 500,
               height: 100,
               border: 1,
               overflow: "auto",
            }}
         >
            <List dense={true}>
               {values.length > 0
                  ? values.map((item, index) => {
                       return (
                          <ListItem key={index}>
                             <ListItemText>{item}</ListItemText>
                          </ListItem>
                       );
                    })
                  : "No items."}
            </List>
         </Box>
      </>
   );
}
